<template>
  <!-- eslint-disable vue/max-attributes-per-line vue/no-static-inline-styles -->
  <section class="mt-16 custom-loader">
    <div class="card wavebg custom-loader__header pt-10">
      HOMEHE
    </div>
    <div class="card wavebg header mb-0 pt-0 mt-10">
      <div class="header-up">
        <span class="" style="width: 97px">Custommm97</span>
        <span class="" style="width: 77px">Custom77</span>
        <span class="" style="width: 51px">Cus51</span>
        <span class="" style="width: 87px">Custom87</span>
        <span class="" style="width: 42px">C42</span>
        <span class="" style="width: 80px">Custom80</span>
        <span class="" style="width: 45px">Cu45</span>
        <span class="" style="width: 70px">Custom70</span>
        <span class="" style="width: 60px">Cust60</span>
        <span class="" style="width: 70px">Custom70</span>
        <span class="" style="width: 37px">Cu37</span>
        <span class="" style="width: 39px">Cu39</span>
        <span class="" style="width: 60px">Cust60</span>
      </div>
      <div class="!tw-flex header-down !tw-justify-between pt-16">
        <div class="!tw-flex header-down-left">
          <div class="empty-select mr-8">
            Not Specified
          </div>
          <div class="form-group mb-0 mt-0">
            <input placeholder="Search..." class="form-control mt-0 mr-8" style="width: 180px">
          </div>
        </div>
        <div class="!tw-flex header-down-right">
          <button class="btn btn-outline-primary btn-sm mr-8" style="width: 93px" disabled>
            Drilldown
          </button>
          <button class="btn btn-outline-primary btn-sm mr-8" style="width: 75px" disabled>
            Report
          </button>
          <button class="btn btn-outline-primary btn-sm mr-8 pl-4 pr-4" style="width: 34px">
            F
          </button>
          <button class="btn btn-outline-primary btn-sm mr-8 pl-4 pr-4" style="width: 34px">
            X
          </button>
          <button class="btn btn-outline-primary btn-sm mr-8" style="width: 82px">
            Refresh
          </button>
          <div class="empty-pagination" style="width: 269px">
            <div class="empty-select mr-8" style="width: 80px">
              100
            </div>
            <span>&lt; &lt;&lt; Page</span>
            <div class="form-group mb-0 mt-0">
              <input placeholder="1" class="form-control mt-0 pl-16 pr-16" style="width: 40px">
            </div>
            <span>of 2 > >></span>
          </div>
        </div>
      </div>

      <div class="header-mob">
        <div class="bookmarks pb-8 mb-16">
          <i class="fas fa-star" />
          Bookmarks
        </div>
        <div class="!tw-flex mb-12">
          <div class="empty-select !tw-w-full mr-8">
            Not Specified
          </div>
          <button class="btn btn-outline-primary btn-sm mr-8 pl-4 pr-4" style="width: 34px; min-width: 34px;">
            F
          </button>
          <button class="btn btn-outline-primary btn-sm mr-8 pl-4 pr-4" style="width: 34px; min-width: 34px;">
            X
          </button>
          <button class="btn btn-outline-primary btn-sm pl-4 pr-4" style="width: 34px; min-width: 34px;">
            X
          </button>
        </div>
        <div class="header-report-sort">
          <div class="sel-wrap !tw-w-full mr-8">
            <label>Report by</label>
            <div class="empty-select !tw-w-full">
              Not Specified
            </div>
          </div>
          <div class="sel-wrap !tw-w-full">
            <label>Sort by</label>
            <div class="empty-select !tw-w-full">
              Not Specified
            </div>
          </div>
        </div>
      </div>

      <div class="table-empty mt-16 mb-8">
        <div class="table-empty__head">
          <!-- <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Actions</div> -->
        </div>
        <div class="table-empty__body">
          <!-- <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div> -->
        </div>
        <div class="table-empty__footer">
          <!-- <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Actions</div> -->
        </div>

        <div class="mob-table__block">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
        </div>
        <div class="mob-table__block">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
        </div>
        <div class="mob-table__footer wavebg">
          Totals
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
// vue3-migration -- '@/assets/theme/common-page-styles.scss'
// @import 'src/assets/theme/default/components/styles-loaders';

</style>
